import {Module} from "@/services/module";

class ForceState extends Module {
  constructor() {
    super("force"); // force => 强制  cache => 缓存
  }
}

export default new ForceState();
